define.alias("ember-truth-helpers/helpers/and", "settings/helpers/and");